import type { EthereumAddress } from "@bracket/types";

export declare type BracketWalletDetail = {
	address: EthereumAddress;
	anonymous: boolean;
}

const BRACKET_WALLET_STORE = new Map<"current", BracketWalletDetail>([
	["current", { address: import.meta.env.VITE_ANON_WALLET_ADDR, anonymous: true, }],
]);

export const getBracketWallet = (): BracketWalletDetail => {
	const result = BRACKET_WALLET_STORE.get("current");
	if(!result) {
		throw new Error("BracketWallet:: no GLOBAL wallet found");
	}
	return result;
}

export const setBracketWallet = ( next: BracketWalletDetail ) => {
	BRACKET_WALLET_STORE.set("current", next);
}

export const setBracketWalletAnonymous = () => {
	BRACKET_WALLET_STORE.set("current", { address: import.meta.env.VITE_ANON_WALLET_ADDR, anonymous: true, });
}
